
import { useAuth } from "@/app/providers/AuthContext";
import { LoadingSpinner } from "@/shared/ui/LoadingSpinner";
import { ReactNode } from "react";

interface AppBootProperties {
  children: ReactNode;
}

/**
 * AppBoot handles the initial loading state while auth is being established.
 * Shows a loading spinner until isReady is true, then renders the app.
 */
export function AppBoot({ children }: AppBootProperties) {
  const { isReady } = useAuth();

  if (!isReady) {
    return <LoadingSpinner />;
  }

  return <>{children}</>;
}